import { useTranslation } from 'next-i18next';

import { Box, Button, useSlotRecipe } from '@chakra-ui/react';

import { Image } from '@nocowanie/common-ui/components/atoms/image';
import { IconsLinear } from '@nocowanie/icons/linear';

import { getAssetUrl } from '@app/helpers/ssr.helpers';
import { useMapRedirect } from '@app/hooks/useMapRedirect';

export const MapEntryPoint = () => {
    const { t } = useTranslation('listing', {
        keyPrefix: 'map',
    });
    const recipe = useSlotRecipe({ key: 'mapEntryPoint' });
    const styles = recipe();
    const handleMapRedirect = useMapRedirect();
    const mapTileUrl = getAssetUrl('listing/map-tile.webp');

    return (
        <Box css={styles.container}>
            <Image
                src={mapTileUrl}
                alt={''}
                loading={'lazy'}
                objectFit={'cover'}
                htmlWidth={320}
                htmlHeight={154}
                ratioProps={{ ...styles.image, ratio: 320 / 154 }}
            />

            <Button variant={'solid'} css={styles.button} onClick={handleMapRedirect}>
                <IconsLinear.Location mr={1.5} />
                {t('viewOnMap')}
            </Button>
        </Box>
    );
};
